import React, { useEffect, useState } from 'react';
import WelcomePage from './components/WelcomePage.js';
import LoginForm from './components/LoginForm.js';
import SessionLogin from './components/SessionLogin.js';
import QuizPage from './components/QuizPage.js';
import ResultPage from './components/ResultPage.js';
import AdminPanel from './components/AdminPanel.js';
import QuizAuditPage from './components/QuizAuditPage.js';
import LeaderboardPage from './components/LeaderboardPage.js';
import { checkStatus, clearToken, getToken } from './api.js';
import './styles.css';

function clearQuizSession() {
  clearToken();
  sessionStorage.removeItem('quizSessionType');
  // Remove credentials written by older deployments, which were shared by all tabs.
  localStorage.removeItem('token');
  localStorage.removeItem('quizSessionType');
}

export default function App() {
  const [stage, setStage] = useState('welcome');
  const [sessionType, setSessionType] = useState(null);
  const [result, setResult] = useState(null);
  const [quizQuestions, setQuizQuestions] = useState([]);

  useEffect(() => {
    const path = window.location.pathname.toLowerCase();
    if (path === '/admin' || path === '/admin/control' || path === '/admin/control/audit' || path === '/admin/control/leaderboard') {
      setStage('admin');
      return;
    }
    // Quiz credentials must be tab-scoped. Never revive shared credentials from
    // older deployments: another tab can have replaced them with a different team.
    localStorage.removeItem('token');
    localStorage.removeItem('quizSessionType');
    const savedSessionType = sessionStorage.getItem('quizSessionType');
    if (getToken() && ['dry-run', 'official'].includes(savedSessionType)) {
      checkStatus().then(status => {
        if (status.valid && status.activeQuizSession) {
          setSessionType(savedSessionType);
          setStage('quiz');
          return;
        }
        if (status.unavailable) return;
        clearQuizSession();
      });
    }
  }, []);

  function startSession(type) {
    setSessionType(type);
    setResult(null);
    setStage('session-login');
  }

  function finishQuiz(quizResult, questions) {
    clearQuizSession();
    setResult(quizResult);
    setQuizQuestions(questions);
    setStage('result');
  }

  function finishRegistration() {
    clearQuizSession();
    setSessionType('registration');
    setResult({});
    setStage('result');
  }

  function returnHome() {
    clearQuizSession();
    setResult(null);
    setQuizQuestions([]);
    setSessionType(null);
    setStage('welcome');
  }

  if (stage === 'admin') {
    if (window.location.pathname.toLowerCase() === '/admin/control/audit') return <QuizAuditPage />;
    if (window.location.pathname.toLowerCase() === '/admin/control/leaderboard') return <LeaderboardPage />;
    return <AdminPanel controls={window.location.pathname.toLowerCase() === '/admin/control'} />;
  }
  if (stage === 'login') return <LoginForm onLogin={finishRegistration} />;
  if (stage === 'session-login') return <SessionLogin sessionType={sessionType} onSuccess={() => { sessionStorage.setItem('quizSessionType', sessionType); setStage('quiz'); }} onBack={returnHome} />;
  if (stage === 'quiz') return <QuizPage sessionType={sessionType} onFinish={finishQuiz} />;
  if (stage === 'result') return <ResultPage result={result} sessionType={sessionType} questions={quizQuestions} onDone={returnHome} />;
  return <WelcomePage onNext={() => setStage('login')} onSession={startSession} />;
}
